import { singleton, inject } from "tsyringe"
import { SendAnalytics } from "@/services/SendAnalytics"
import { AwEvent } from "@/models/AwEvent"
import { AwEventStore } from "@/models/AwEventStore"
import { RootLogger } from "loglevel"
export interface IAnalytics {
  setUp(webid: number, url: string, logger: RootLogger): void
  register(aw: AwEventStore): void
}
export class Analytics implements IAnalytics {
  private analyticsArray: AwEventStore[] = new Array()
  private url: string = ""
  private webinarId: number = -1
  private logger?: RootLogger
  public setUp(webid: number, url: string, logger: RootLogger) {
    this.url = url
    this.webinarId = webid
    this.logger = logger
  }
  public register(aw: AwEventStore) {
    this.analyticsArray.push(aw)
    const event: AwEvent = {
      eventsStore: this.analyticsArray,
      webinarId: this.webinarId
    }
    SendAnalytics(event, this.url, this.logger)
    this.analyticsArray = new Array()
  }
}
export class MockAnalytics implements IAnalytics {
  private logger?: RootLogger
  public setUp(webid: number, url: string, logger: RootLogger) {
    this.logger = logger
  }
  public register(aw: AwEventStore) {
    if (this.logger)
      this.logger.info(
        `Mock Widget Analytics Registered :: { event : ${JSON.stringify(aw)} }`
      )
  }
}

@singleton()
export class AnalyticsClient {
  private _client: IAnalytics
  constructor(@inject("AnalyticsService") public client: IAnalytics) {
    this._client = client
  }
  public setUp(webid: number, url: string, logger: RootLogger) {
    this._client.setUp(webid, url, logger)
  }
  public register(aw: AwEventStore) {
    this._client.register(aw)
  }
}
